'use client';
import { useEffect, useState } from 'react';
import { motion } from 'motion/react';

const MarkupElement = ({ markup }) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const createMarkup = () => {
    return { __html: markup };
  };
  
  // Retourner null au lieu de false pour éviter les problèmes d'hydratation
  if (!isClient) {
    return null;
  }
  
  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      className={'p-2 welcome-message imported-text-from-BE-forms'}
      dangerouslySetInnerHTML={createMarkup()}
    />
  );
};

export default MarkupElement;
